import { render, staticRenderFns } from "./EditorContainer.vue?vue&type=template&id=3a288af6"
import script from "./EditorContainer.vue?vue&type=script&lang=ts"
export * from "./EditorContainer.vue?vue&type=script&lang=ts"
import style0 from "./EditorContainer.vue?vue&type=style&index=0&id=3a288af6&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports